import { getApi, getApiCSV, postApi } from 'apis';

const getAvailableEmployees = async (data: any) => {
	return await getApi('/employee-mapping/available-employees', data);
};
const getAllMappedEmployees = async (data: any) => {
	return await getApi('/employee-mapping/all', data);
};
const removeEmployeeMapping = async (data: { employeeIds: string[] }) => {
	return await postApi(`/employee-mapping/remove`, data);
};

const createEmployeeMapping = async (data: any) => {
	return await postApi('/employee-mapping', data);
};

const downloadAttendanceSheetForSupervisor = async (supervisorId: string) => {
	return await getApiCSV(`/employee-mapping/attendance-sheet`, {
		supervisorId: supervisorId,
	});
};

const uploadAttendanceSheetForSupervisor = async (data: any) => {
	return await postApi(
		'/employee-mapping/upload-attendance-sheet',
		data,
		true
	);
};

const getSupervisors = async () => {
	return await getApi('/employee-mapping/options');
};

export const employeeMappingApi = {
	getAvailableEmployees,
	createEmployeeMapping,
	removeEmployeeMapping,
	getAllMappedEmployees,
	downloadAttendanceSheetForSupervisor,
	getSupervisors,
	uploadAttendanceSheetForSupervisor,
};
